module.exports = __webpack_public_path__ + "img/traffic-light-slow.b9a27454.svg";